angular.module("ainapp")
    .controller("billReviewController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$http",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $http) {

            $scope.PageName = "Bill Review";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.CProfile = {};
            MainService.GetCompanyProfile().then(function (res) {
                if (res.data != null) {
                    $scope.CProfile = res.data;
                }
            })


            $scope.Init = function () {
                $scope.Track = {
                    BillNo: "",
                }

                $scope.Load = true;
                $scope.TrackResult = {};

                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.getLastBill().then(function (response) {
                    if (response.data) {
                        $scope.TrackResult = response.data;
                    } else {
                        toastr.warning("Bill No Not Found");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });

            }
            $scope.Init();


            $scope.TrackBill = function () {
                if ($scope.Track.BillNo == "") {
                    toastr.warning("Enter Bill No");
                } else {

                    $scope.Load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.TrackBillNo($scope.Track.BillNo).then(function (response) {
                        if (response.data) {
                            $scope.TrackResult = response.data;
                        } else {
                            toastr.warning("Bill No Not Found");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    });
                }
            }

            $scope.GoPrev = function () {
                $scope.Load = true;
                var Id = $scope.TrackResult.Id - 1;
                if (Id > 0) {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.CounterSalesById(Id).then(function (response) {
                        if (response.data) {
                            if (response.data.IsActive) {
                                $scope.TrackResult = response.data;
                            } else {
                                $scope.TrackResult.Id = $scope.TrackResult.Id - 1;
                                $scope.GoPrev();
                            }

                        } else {
                            toastr.warning("Bill No Not Found");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    });
                }
            }

            $scope.GoNext = function () {
                $scope.Load = true;
                var Id = $scope.TrackResult.Id + 1;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.CounterSalesById(Id).then(function (response) {
                    if (response.data) {
                        if (response.data.IsActive) {
                            $scope.TrackResult = response.data;
                        } else {
                            $scope.TrackResult.Id = $scope.TrackResult.Id + 1;
                            $scope.GoNext();
                        }
                    } else {
                        toastr.warning("Bill No Not Found");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }


            $scope.DeleteSale = function (data) {

                if ($scope.PageAccessInfo.IsRemove == false) {
                    toastr.info("You Dont Have Access To Delete Data");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#myModal2").modal("show");
                }

            }

            $scope.deleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteCounterSales($scope.TrackResult.Id).then(function (response) {
                    if (response.data) {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $scope.Init();
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.editOrder = function () {
                if ($scope.PageAccessInfo.IsEdit == false) {
                    toastr.info("You Dont Have Access To Edit Data");
                } else {
                    $state.go("counterSalesEdit", {
                        SaleId: $scope.TrackResult.Id,
                    });
                }

            }


            $scope.Print = function () {


                if ($scope.CProfile.PrinterName == "PDF") {
                    $scope.PrintInvoice($scope.TrackResult.Id, "Counter Sales", $scope.TrackResult.BillNo);
                } else {

                    $scope.SalesPrint = $scope.TrackResult;


                    $("#confirmmodal").modal("hide");
                    $.LoadingOverlay("hide");

                    $scope.SalesPrint.Settings = {
                        PrinterName: $scope.CProfile.PrinterName,
                        PrinterType: 'Default',
                        ItemLength: 40,
                        PrintLogo: true,
                        ThankYouNote: 'Thank You.Visit Again.',
                        EIDRMK: 'Thank you',
                        PrintType: 'Cash',
                        Logo: $scope.basePath + $scope.CProfile.Logo,
                        TaxType: "TAX INVOICE (Duplicate)",
                        CompanyName: $scope.CProfile.Name,
                        CompanyMobile: $scope.CProfile.MobileNo,
                        CompanyAddress: $scope.CProfile.Address,
                        CompanyEmail: $scope.CProfile.Email,
                        CompanyTRNNO: $scope.CProfile.TRNNo,
                        CompanyWebsite: $scope.CProfile.Website,
                        Staff: $scope.TrackResult.Employee.Name,
                        ClientName: $scope.TrackResult.AccountMaster.Name,
                        ClientMobile: $scope.TrackResult.AccountMaster.MobileNo,
                        LogoPath: "D:\\Logo.jpeg",
                        Format: 1,
                    };

                    $http.post('http://localhost:8090/Party/Print/', $scope.SalesPrint)
                        .then(function (response) {
                            console.log(response.data);
                            $scope.Init();
                        })
                        .catch(function (error) {
                            //                                console.error('Error:', error);
                            //                                $scope.Init();
                            toastr.error("Print Error");
                        });

                }


            }





        }])
